import React from "react";
import { Modal } from "react-bootstrap";
import "../../css/rentals/rentals.css";

class RentalSetToPreparationModal extends React.Component {
  render() {
    const {
      show,
      rental,
      isLoading,
      onClose,
      onConfirm,
    } = this.props;

    if (!show || !rental) return null;

    const productName = rental.product_name || (rental.product ? rental.product.designation : "Produit");

    return (
      <Modal
        show={show}
        onHide={onClose}
        backdrop={isLoading ? "static" : true}
        keyboard={!isLoading}
        centered
        size="md"
        className="rental-delivery-confirm-modal"
        dialogClassName="modal-dialog-rounded"
      >
        <Modal.Header style={{ backgroundColor: '#17a2b8', color: '#fff', borderTopLeftRadius: '0.5rem', borderTopRightRadius: '0.5rem' }}>
          <Modal.Title className="rental-modal-title">
            Passer en préparation
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="rental-modal-body">
          <div className="rental-modal-body-inner">
            <h5 className="rental-modal-product-name">
              Confirmer le passage en préparation
            </h5>
            <p className="rental-modal-form-hint">
              Êtes-vous sûr de vouloir passer la location de <strong>{productName}</strong> en préparation ?
            </p>
            <p className="rental-modal-form-hint">
              La location passera au statut <strong className="text-info">En préparation</strong>.
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer className="rental-modal-footer" style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="btn btn-secondary"
            style={{ flex: 1 }}
          >
            Annuler
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isLoading}
            className="btn btn-info"
            style={{ flex: 1, color: '#fff' }}
          >
            {isLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span> Confirmation en cours...</span>
              </>
            ) : (
              "Confirmer"
            )}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default RentalSetToPreparationModal;
